import { render, staticRenderFns } from "./FaceStatistics.vue?vue&type=template&id=03a83958&scoped=true"
import script from "./FaceStatistics.vue?vue&type=script&lang=js"
export * from "./FaceStatistics.vue?vue&type=script&lang=js"
import style0 from "./FaceStatistics.vue?vue&type=style&index=0&id=03a83958&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a83958",
  null
  
)

export default component.exports